class Customer.Methods.DateDifferenceCalculator

  constructor: (offsetTimeFromServer) ->
    #When Server's Time is different from Frontend's Time causes a weird behavior on differenceTillNow and reverseDifferenceTillNow, so we add this difference to new Date()
    @offset_in_miliseconds = offsetTimeFromServer

  differenceTillNow: (fromDate, threshold) =>
    now = new Date(Date.now() + @offset_in_miliseconds)
    from = if fromDate then new Date(fromDate) else now
    @difference(from, now, threshold)

  reverseDifferenceTillNow: (fromDate, threshold) =>
    now = new Date(Date.now() + @offset_in_miliseconds)
    from = if fromDate then new Date(fromDate) else now
    @reverseDifference(from, now, threshold)

  differenceFromTo: (fromDate, toDate, threshold) =>
    to = new Date(toDate)
    from = new Date(fromDate)
    @difference(from, to, threshold)

  reverseDifferenceFromTo: (fromDate, toDate, threshold) =>
    to = new Date(toDate)
    from = new Date(fromDate)
    @reverseDifference(from, to, threshold)

  difference: (from, to, threshold) =>
    difference = (to-from)
    {
      standarizedDifference: @differenceInHoursMinutesSeconds(difference)
      thresholdPercentage: @thresholdPercentage(difference, threshold)
    }

  reverseDifference: (from, to, threshold) =>
    difference = to - from
    if difference == 0
      thresholdPercentage = 0
    else
      difference = threshold - difference
      thresholdPercentage = @invertedThresholdPercentage(difference, threshold)
    {
      standarizedDifference: @differenceInHoursMinutesSeconds(difference)
      thresholdPercentage: thresholdPercentage
    }

  differenceInHoursMinutesSeconds: (difference) =>
    negative = difference < 0
    if negative
      difference = difference * (-1)
    # days=Math.floor(difference/(60*60*1000*24)*1)
    # hours=Math.floor((difference%(60*60*1000*24))/(60*60*1000)*1)
    hours= Math.floor(difference/(60*60*1000)*1)
    mins = Math.floor(((difference%(60*60*1000*24))%(60*60*1000))/(60*1000)*1)
    secs = Math.floor((((difference%(60*60*1000*24))%(60*60*1000))%(60*1000))/1000*1)
    {
      hours: @hourString(hours)
      minutes: @minString(mins)
      seconds: @secString(secs)
      negative: negative
    }

  hourString: (hours) =>
    if hours < 10
      hours = "0#{hours}"
    "#{hours}"

  minString: (mins) =>
    if mins < 10
      mins = "0#{mins}"
    "#{mins}"

  secString: (secs) =>
    if secs < 10
      secs = "0#{secs}"
    "#{secs}"

  thresholdPercentage: (difference, threshold) =>
    if threshold && threshold > 0
      (100*difference)/threshold
    else
      0

  invertedThresholdPercentage: (difference, threshold) =>
    if difference < 0
      return 101
    100 - @thresholdPercentage(difference, threshold)